module.exports = __webpack_public_path__ + "static/images/refund_us.347d25ec486c02e3892d9e971ce6411e.png";